import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { Feature } from '../../core/models/feature.model';
import { updateEntities } from '../utils';
import { dispatchRequest } from '../dispatch-request';
import {
  GetLastActiveFeatureAction,
  GetLastActiveFeatureFailAction,
  GetLastActiveFeatureSuccessAction,
  SaveFeatureCloseAction,
  SaveFeatureCloseFailAction,
  SaveFeatureCloseSuccessAction,
} from './feature.actions';


export interface FeatureStateModel {
  entities: { [key: number]: Feature };
  ids: number[];
  lastActiveFeatureId: number;
}

@State<FeatureStateModel>({
  name: 'feature',
  defaults: {
    entities: {},
    ids: [],
    lastActiveFeatureId: null,
  },
})
@Injectable()
export class FeatureState {

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  @Action(GetLastActiveFeatureAction)
  getLastActiveFeature(
    ctx: StateContext<FeatureStateModel>,
  ) {
    const request = this.httpClient.get('GetLastActiveFeature');

    return dispatchRequest(
      request,
      ctx,
      GetLastActiveFeatureSuccessAction,
      GetLastActiveFeatureFailAction,
    );
  }

  @Action(GetLastActiveFeatureSuccessAction)
  getLastActiveFeatureSuccess(
    ctx: StateContext<FeatureStateModel>,
    action: GetLastActiveFeatureSuccessAction,
  ) {
    if (action.payload) {
      const stateUpdate = updateEntities(action.payload, Feature);
      ctx.patchState({
        ...stateUpdate,
        lastActiveFeatureId: action.payload.id,
      });
    }
  }

  @Action(SaveFeatureCloseAction)
  saveFeatureClose(
    ctx: StateContext<FeatureStateModel>,
  ) {
    const { lastActiveFeatureId: featureId } = ctx.getState();
    const request = this.httpClient.post('SaveFeatureClose', { featureId });

    return dispatchRequest(
      request,
      ctx,
      SaveFeatureCloseSuccessAction,
      SaveFeatureCloseFailAction,
    );
  }

  @Action(SaveFeatureCloseSuccessAction)
  saveFeatureCloseSuccess(
    ctx: StateContext<FeatureStateModel>,
  ) {
    ctx.patchState({
      lastActiveFeatureId: null,
    });
  }
}
